var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_975_27976)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7927 35.6263C47.8246 36.7626 46.6674 38.9134 46.8035 41.1819L48.9952 77.6965L33.4819 86.6532C31.2761 87.9267 29.6666 90.0243 29.0074 92.4845C28.3482 94.9447 28.6933 97.566 29.9668 99.7718L49.7861 134.1C51.0596 136.306 53.1572 137.915 55.6174 138.574C58.0777 139.234 60.699 138.889 62.9048 137.615L81.6292 126.804C81.6293 126.804 81.6294 126.804 81.6295 126.804L130.002 98.8762C132.787 97.2674 134.889 94.6976 135.914 91.6491C136.939 88.6006 136.816 85.2829 135.569 82.3184L118.629 42.167L118.629 42.166C117.902 40.4396 116.817 38.8875 115.444 37.6127C114.072 36.3376 112.443 35.3692 110.668 34.7717C108.892 34.1742 107.01 33.9613 105.146 34.1471C103.281 34.3329 101.478 34.9132 99.8553 35.8495L80.0841 47.2644L77.6789 43.0984C74.9718 38.4096 70.513 34.9882 65.2833 33.5869C60.0537 32.1856 54.4815 32.9192 49.7927 35.6263ZM80.8253 113.412L123.999 88.4856C124.254 88.3386 124.446 88.1037 124.54 87.8251C124.633 87.5467 124.622 87.2438 124.508 86.973L107.568 46.8209C107.502 46.6631 107.403 46.5212 107.277 46.4046C107.152 46.2881 107.003 46.1996 106.841 46.145C106.678 46.0904 106.506 46.0709 106.336 46.0879C106.166 46.1049 106.001 46.1579 105.852 46.2435L80.888 60.6567C78.0182 62.3136 74.3487 61.3303 72.6918 58.4606L67.2866 49.0984C66.1708 47.1658 64.333 45.7556 62.1775 45.178C61.1492 44.9025 60.0887 44.8272 59.051 44.945L61.111 79.266L80.8253 113.412ZM58.9802 126.024L41.5573 95.8472L53.0102 89.2349L70.433 119.412L58.9802 126.024Z",
    fill: "url(#paint0_linear_975_27976)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_975_27976",
    x1: 30.8677,
    y1: 101.332,
    x2: 122.398,
    y2: 48.4873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CDC65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06C778"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_975_27976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.312,
    height: 115.312,
    fill: "white",
    transform: "translate(0.576172 58.4868) rotate(-30)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbOk);
export default __webpack_public_path__ + "static/media/thumb-ok.a9cf22904cd149669060a2a5fa98860e.svg";
export { ForwardRef as ReactComponent };